import React from 'react';
import { primaryVolumes, secondaryVolumes, Volume } from '../data/content';
type VolumeGroupProps = {
  title: string;
  subtitle: string;
  volumes: Volume[];
};
function VolumeGroup({
  title,
  subtitle,
  volumes
}: VolumeGroupProps) {
  return <div data-id="element-230" data-mp="kvzprkxqx3gh">
      <div className="flex items-baseline gap-3 border-b border-navy/10 pb-4" data-id="element-231" data-mp="kyc2njoncnmo">
        <h3 className="font-display text-xl font-black tracking-tight text-navy" data-id="element-232" data-mp="ptrgwcqkgljm">
          {title}
        </h3>
        <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-teal" data-id="element-233" data-mp="b54yg25n7do6">
          {subtitle}
        </span>
      </div>
      <ul className="mt-6 space-y-3" data-id="element-234" data-mp="2605rcgriejx">
        {volumes.map(volume => <li key={volume.number} className="group relative flex items-start gap-4 overflow-hidden rounded-2xl bg-cream py-4 pl-6 pr-5 transition-colors duration-200 hover:bg-navy-light" data-id="element-235" data-mp="23x3nu2c4uyu">
            <span aria-hidden="true" className="absolute inset-y-0 left-0 w-1.5" style={{
          backgroundColor: volume.accent
        }} data-id="element-236" data-mp="3tbrr7yjlh30e" />
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full font-display text-sm font-bold text-white" style={{
          backgroundColor: volume.accent
        }} data-id="element-237" data-mp="3cvquqmtjlhfr">
              {volume.number}
            </span>
            <div data-id="element-238" data-mp="3htijx92sypg9">
              <div className="flex flex-wrap items-baseline gap-x-2" data-id="element-239" data-mp="3hqwbl78385wz">
                <h4 className="font-display text-base font-bold text-navy" data-id="element-240" data-mp="2u47p0884vpa1">
                  {volume.title}
                </h4>
                <span className="text-[10px] font-bold uppercase tracking-[0.12em] text-navy/40" data-id="element-241" data-mp="2p2iectotpdmh">
                  {volume.level}
                </span>
              </div>
              <p className="mt-1 text-xs leading-relaxed text-navy/55" data-id="element-242" data-mp="2y3gm9n2du5ac">
                {volume.text}
              </p>
            </div>
          </li>)}
      </ul>
    </div>;
}
export function WhatsInside() {
  return <section id="contenuto" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-243" data-mp="26c0yvqt04ej2">
      <div className="mx-auto max-w-4xl" data-id="element-244" data-mp="9cxus0ga2dbz">
        <div className="text-center" data-id="element-245" data-mp="ec0wpc0yo3fq">
          <span className="text-[11px] font-bold uppercase tracking-[0.22em] text-teal" data-id="element-246" data-mp="eazkv5c4fcwy">
            8 volumi digitali · PDF ad alta risoluzione
          </span>
          <h2 className="mt-4 font-display text-[1.9rem] font-black leading-tight tracking-tight text-navy sm:text-[2.6rem]" data-id="element-247" data-mp="o2n8sw9gybto">
            <span aria-hidden="true" data-id="element-248" data-mp="3mksrudet81ov">🎼 </span>Cosa trovi dentro il pack{' '}
            <span className="italic text-grape" data-id="element-249" data-mp="3riau5kybninw">Musica Pronta?</span>
          </h2>
        </div>

        <div className="mt-12 grid gap-10 md:grid-cols-2" data-id="element-250" data-mp="bzy6386583f">
          <VolumeGroup title="Scuola Primaria" subtitle="5 volumi" volumes={primaryVolumes} data-id="element-251" data-mp="em6w66sptn8" />
          <VolumeGroup title="Scuola Media" subtitle="3 volumi" volumes={secondaryVolumes} data-id="element-252" data-mp="1bs7uhmx0bn6n" />
        </div>
      </div>
    </section>;
}